export default __webpack_public_path__ + "img/pin_icons/microphone_w.svg";